import { Component } from "react";
import Context from "../context/context";

class Logout extends Component {
    // constructor(props) {
    //     super(props);

    // }  // not used

    render() {
        Context.Logout();
        window.document.location = "/login";
        //this.props.history.push("/login");

        return null;
    }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/pages/logout.js